export default "__VITE_ASSET__Co1mgEEQ__"